import Rectangle from "./Rectangle";
import Area from "./Area";
import Length from "./Length";
import AbstractShape from "./AbstractShape";

export default class Ellipse extends AbstractShape {
	static NAME = "ellipse";

	constructor( width, height ) {
		super();

		this.width = width;
		this.height = height;
	}

	get_name() {
		return Ellipse.NAME;
	}

	get_enclosing_rectangle() {
		return new Rectangle( this.width, this.height );
	}

	get_area() {
		const a = this.width.in_mm() / 2;
		const b = this.height.in_mm() / 2;
		return new Area( Math.PI * a * b );
	}

	get_circumference() //This is a mathematical property of an ellipse.
	{
		const a         = this.width.in_mm() / 2;
		const b         = this.height.in_mm() / 2;
		const h         = Math.pow( a - b, 2 ) / Math.pow( a + b, 2 );
		const perimeter = Math.PI * (
			a + b
		) * (
			1 + 3 * h / (
				10 + Math.sqrt( 4 - 3 * h )
			)
		);
		return new Length( perimeter );
	}

	get_width() {
		return this.width;
	}

	get_height() {
		return this.height;
	}

	get_maximum_dimensions( maximum_rectangle ) //Because customers can rotate their ellipse, simply assume width must be the longest.
	{
		return {
			width: maximum_rectangle.get_longest_side(),
			height: maximum_rectangle.get_shortest_side()
		};
	}

	get_dimension_keys() {
		return [ "width", "height" ];
	}

	get_modifier_keys() {
		return [];
	}

	serialize_primitives() {
		return {
			width: this.width.in_mm(),
			height: this.height.in_mm()
		};
	}

	static deserialize_primitives( primitives ) {
		return new Ellipse( new Length( primitives.width ), new Length( primitives.height ) );
	}
}
